import React from "react";
import "../../Styles/HomeComponentsStyles/FooterPart.css";
import {
  Box,
  createTheme,
  Stack,
  ThemeProvider,
  Avatar,
  Typography,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../../images/investchartslogo.png";
import TwitterIcon from "@mui/icons-material/Twitter";
import EmailIcon from "@mui/icons-material/Email";
import styled from "@emotion/styled";

const MenuComponent = styled(Box)(({ theme }) => ({
  color: "#080808",
  fontFamily: "public sans",
  fontSize: "18px",
  width: "maxContent",

  "&:hover": {
    color: "#09c08d",
    cursor: "pointer",
  },

  // [theme.breakpoints.up("sm")]: {
  //   display: "none",
  // },
}));

const FooterPart = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="footer__part__wrapper"></div>
      <div className="footer__part__portion">
        <Box
          sx={{
            padding: "80px 80px",
            display: "flex",
            flexDirection: "column",
            gap: "50px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "30px" }}>
            <Typography sx={{ fontFamily: "public sans", fontSize: "26px" }}>
              Create your account.
            </Typography>
            <Box
              sx={{
                backgroundColor: "#0f1728",
                fontFamily: "public sans",
                fontSize: "18px",
                padding: "6px 20px",
                borderRadius: "30px",
                cursor: "pointer",
                color: "white",
              }}
            >
              Get Started
            </Box>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            {" "}
            <Box
              sx={{
                height: "200px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <Box>
                <img src={logo} height="60px" onClick={() => navigate("/")} />
              </Box>
              <Box sx={{ display: "flex", padding: "0 20px", gap: "7px" }}>
                <TwitterIcon />
                <EmailIcon />
              </Box>
            </Box>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: " 30% 30% 30%",
                gap: "40px",
                width: "60%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "right",
                  gap: "10px",
                }}
              >
                <MenuComponent>Stocks</MenuComponent>
                <MenuComponent>Press Releases</MenuComponent>
                <MenuComponent>Earnings</MenuComponent>
                <MenuComponent>Pricing</MenuComponent>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "right",
                  gap: "10px",
                }}
              >
                <MenuComponent>Getting Started</MenuComponent>
                <MenuComponent>Crypto</MenuComponent>
                <MenuComponent>Core Data</MenuComponent>
                <MenuComponent>Market</MenuComponent>
                <MenuComponent>Economic Data</MenuComponent>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "right",
                  gap: "10px",
                }}
              >
                <MenuComponent>About</MenuComponent>
                <MenuComponent>Contact</MenuComponent>
                <MenuComponent>FAQs</MenuComponent>
                <MenuComponent>Account</MenuComponent>
                <MenuComponent>Company</MenuComponent>
              </Box>
            </Box>
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default FooterPart;
